import {
  convertLabelMapToConfig,
  convertLabelUomMapToConfig,
  mergeConfig,
} from 'Components/Worksheets/Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.FractionTested`]: 'Fraction Tested',
      [`${prefix}.Preparation.OversizeParticlesTreatment`]: 'Treatment of Oversize Particles (> 63.0 mm)',
      [`${prefix}.Preparation.UpperAggregateSieveSizeId`]: 'Upper Aggregate Size',
      [`${prefix}.Preparation.MinimumSampledMass`]: 'Minimum Test Portion Mass',
      [`${prefix}.Preparation.TareMass`]: 'Preparation Tare Mass',
      [`${prefix}.Preparation.TarePlusSampledMass`]: 'Tare and Test Portion Mass',
      [`${prefix}.Preparation.SampledMass`]: 'Test Portion Mass',

      [`${prefix}.Equipment.Balance`]: 'Preparation Balance',
      [`${prefix}.Equipment.SoakingThermometer`]: 'Soaking Thermometer',
      [`${prefix}.Equipment.Clock`]: 'Clock',
      [`${prefix}.Equipment.TestThermometer`]: 'Test Thermometer',
      [`${prefix}.Equipment.MeasurementBalance`]: 'Balance',
      [`${prefix}.Equipment.WireBasket`]: 'Wire Basket',

      [`${prefix}.Measurements.InitialWaterTemperature`]: 'Initial Water Temperature',
      [`${prefix}.Measurements.SoakingStartTime`]: 'Soaking Started',
      [`${prefix}.Measurements.SoakingEndTime`]: 'Soaking Ended',
      [`${prefix}.Measurements.SoakingPeriod`]: 'Soaking Period',
      [`${prefix}.Measurements.MinimumSoakingWaterTemperature`]: 'Minimum Soaking Water Temperature',
      [`${prefix}.Measurements.MaximumSoakingWaterTemperature`]: 'Maximum Soaking Water Temperature',
      [`${prefix}.Measurements.SampleWaterTemperature`]: 'Test Water Temperature',
      [`${prefix}.Measurements.WaterDensityAtTestTemperature`]: 'Water Density at Test Temperature',
      [`${prefix}.Measurements.BasketAndTestPortionMassInWater`]: 'Basket and Test Portion Mass in Water',
      [`${prefix}.Measurements.EmptyBasketMassInWater`]: 'Empty Basket Mass in Water',

      [`${prefix}.Measurements.ConstantDryMass.Equipment.DryMassBalance`]: 'Drying Balance',
      [`${prefix}.Measurements.ConstantDryMass.DryingTray.WetSoilAndContainerMass`]: 'Tare and Test Portion Mass',
      [`${prefix}.Measurements.ConstantDryMass.DryingTray.WetSoilMass`]: 'Test Portion SSD Mass',
      [`${prefix}.Measurements.ConstantDryMass.DryingTray.DryMassReadings.DateTimeRemovedFromOvenLocal`]: 'Date and Time Out of Oven',
      [`${prefix}.Measurements.ConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: `Tare & Dry Mass`,
      [`${prefix}.Measurements.ConstantDryMass.DryingTray.ConstantDrySoilMass`]: 'Test Portion Oven-dried Mass',

      [`${prefix}.Results.TestPortionMass`]: 'Test Portion Mass',
      [`${prefix}.Results.TestWaterTemperature`]: 'Test Water Temperature',
      [`${prefix}.Results.ReportTestPortionMass`]: 'Test Portion Mass',
      [`${prefix}.Results.ReportTestWaterTemperature`]: 'Test Water Temperature',

      [`${prefix}.Results.FractionTested`]: 'Fraction Tested',
      [`${prefix}.Results.ApparentParticleDensity`]: 'Apparent Particle Density',
      [`${prefix}.Results.OvenDriedParticleDensity`]: 'Oven-dried Particle Density',
      [`${prefix}.Results.SaturatedAndSurfaceDriedParticleDensity`]: 'Saturated and Surface-dried Particle Density',

      [`${prefix}.Results.WaterAbsorption`]: 'Water Absorption',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Preparation.UpperAggregateSieveSizeId`]: 'mm',
      [`${prefix}.Results.WaterAbsorption`]: '%',
    })
  );

export default getLabelConfig;
